import CancelIcon from "@material-ui/icons/CancelRounded";
import { Button, Link } from "@material-ui/core";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

const NotAuthorizedPage = () => {
  const history = useHistory();
  const [countDown, setCountdown] = useState(3);

  console.log(countDown);

  if (countDown === 0) {
    history.push("/dashboard");
  }

  useEffect(() => {
    const timeout = setTimeout(() => {
      setCountdown(countDown - 1);
    }, 1000);

    return () => clearTimeout(timeout);
  }, [countDown]);
  return (
    <div style={{ height: "100%" }}>
      <h1>Oops, anda tidak diperbolehkan membuka halaman ini!</h1>
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 507.2 507.2"
        style={{ enableBackground: "new 0 0 507.2 507.2" }}
        height={400}
        width={400}
      >
        <circle style={{ fill: "#F15249" }} cx="253.6" cy="253.6" r="253.6" />
        <path
          style={{ fill: "#AD0E0E" }}
          d="M147.2,368L284,504.8c115.2-13.6,206.4-104,220.8-219.2L367.2,148L147.2,368z"
        />
        <path
          style={{ fill: "#FFFFFF" }}
          d="M373.6,309.6c11.2,11.2,11.2,30.4,0,41.6l-22.4,22.4c-11.2,11.2-30.4,11.2-41.6,0l-176-176
	c-11.2-11.2-11.2-30.4,0-41.6l23.2-23.2c11.2-11.2,30.4-11.2,41.6,0L373.6,309.6z"
        />
        <path
          style={{ fill: "#D6D6D6" }}
          d="M280.8,216L216,280.8l93.6,92.8c11.2,11.2,30.4,11.2,41.6,0l23.2-23.2c11.2-11.2,11.2-30.4,0-41.6
	L280.8,216z"
        />
        <path
          style={{ fill: "#FFFFFF" }}
          d="M309.6,133.6c11.2-11.2,30.4-11.2,41.6,0l23.2,23.2c11.2,11.2,11.2,30.4,0,41.6L197.6,373.6
	c-11.2,11.2-30.4,11.2-41.6,0l-22.4-22.4c-11.2-11.2-11.2-30.4,0-41.6L309.6,133.6z"
        />
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
      </svg>

      <div style={{ marginTop: 20 }}>
        <Link href="/dashboard">Kembali ke dashboard ... {countDown}</Link>
      </div>
    </div>
  );
};

export default NotAuthorizedPage;
